import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazzbet/bazz.bet/bzfront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/app/[locale]/bonuses/page.module.scss");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/components/layouts/page-header/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/components/UI/BackButton/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/domains/bonus/components/cashback/index.tsx");
